export const REPORT = {
  CHAT: 'chat',
  PARTICIPANT: 'participant'
}
export const REPORT_HEADER = {
  MESSAGE: ['Вопрос', 'Скрытый', 'Удален', 'Время', 'Автор', 'Содержание'],
  USER: ['ФИО', 'Почта', 'Логин']
}
